import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, IconButton, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { Dashboard, People, Business, Event, ExitToApp } from '@mui/icons-material';
import './Sidebar.css';

const Sidebar = () => {
  return (
    <Drawer
      sx={{
        width: 200,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          backgroundColor: '#2c3e50',
          color: '#ecf0f1',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <div className="sidebar-header mt-6">
        {/* <Typography variant="h5" sx={{ paddingLeft: 2, paddingTop: 10, color: '#ecf0f1' }}>
          
        </Typography> */}
      </div>

   
      {/* <Divider />  */}

      <List>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/" exact activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/verification" exact activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Approvals" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/cities" exact activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Cities" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/city-analytics" activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="City Analytics" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/city-traffic" activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Traffic Signal" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/testing" exact activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Testing Numbers" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/withdrawals" exact activeClassName="active-link">
            <ListItemIcon>
              <Dashboard sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Withdrawal Requests" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/customers" activeClassName="active-link">
            <ListItemIcon>
              <People sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Customers" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/partners" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Partners" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/deleted-users" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Deleted Users" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/categories" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Categories" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/sub-categories" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Sub-Categories" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/category-groups" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Category Groups" />
          </ListItemButton>
        </ListItem>
         <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/send-notifications" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Send Notification" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/managers" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Managers" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/requests" activeClassName="active-link">
            <ListItemIcon>
              <Event sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Requests" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/bookings" activeClassName="active-link">
            <ListItemIcon>
              <Event sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Bookings" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/cancled" activeClassName="active-link">
            <ListItemIcon>
              <Event sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Cancel Requests" />
          </ListItemButton>
        </ListItem>
      
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/payments" activeClassName="active-link">
            <ListItemIcon>
              <Event sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Payments" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/promotional-ads" activeClassName="active-link">
            <ListItemIcon>
              <Business sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Promotional Ads" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={NavLink} to="/partner-map" activeClassName="active-link">
            <ListItemIcon>
              <Event sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText primary="Partner's View" />
          </ListItemButton>
        </ListItem>

        <Divider />

        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <ExitToApp sx={{ color: '#ecf0f1' }} />
            </ListItemIcon>
            <ListItemText onClick={()=>{localStorage.clear();window.location.reload()}} primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
